'use client'
import { api } from '@/shared/api/client-api'
import { API_END_POINTS } from '@/shared/api/end-points'
import { methods } from '@/shared/api/constants'
import { RestorePasswordByEmailDto } from '../../lib'
import { objectToFormData } from '@/shared/lib/helpers/object-methods'

const restorePasswordByEmail = async (data: RestorePasswordByEmailDto) => {
  const dto = { ...data, action: 'reset' }
  const formData = objectToFormData(dto)
  const res = await api.json<string>(API_END_POINTS.auth.restorePasswordByEmail, {
    method: methods.post,
    body: formData,
  })

  return res
}

export default restorePasswordByEmail
